import { memo } from 'react';
import { StampPreview } from '@dealstack/frontend/shared/components/StampPreview/StampPreview.tsx';
import { Shell } from './FixedPlacementBox.styled.ts';
import { computePreviewScale, pdfToBrowser } from './placement.utils.ts';
import type { FixedPlacement, PageDimensionsPt } from './PlacementCanvas.types.ts';

interface Props {
	fixed: FixedPlacement;
	/** The page the box sits on. */
	dims: PageDimensionsPt;
	scale: number;
	showMetadata: boolean;
}

/** Read-only: another party's box, kept clear of but never moved. Memoised: its props never
 *  change during a drag, while the page's drop preview does. */
export const FixedPlacementBox = memo(function FixedPlacementBox({
	fixed,
	dims,
	scale,
	showMetadata,
}: Props) {
	const box = pdfToBrowser(fixed.pdfBox, dims.heightPt, scale);
	return (
		<Shell style={box} data-testid="placement-fixed-box">
			<StampPreview
				slotLabel={fixed.label}
				isWitness={fixed.isWitness}
				kind={fixed.kind}
				showMetadata={showMetadata}
				scale={computePreviewScale(box.width)}
			/>
		</Shell>
	);
});
